<div *ngIf="tenantInfoCallStorage && maxCallRatio" class="grid-2-resize">
    <ac-slider *ngIf="maxCalls.options"
               label="Max Calls"
               [acModel]="maxCalls.current"
               [options]="maxCalls.options"
               [showTooltip]="true"
               tooltipText="Drag or Type Number"
               (acModelChange)="maxCallsChange($event)"
    ></ac-slider>


    <ac-slider *ngIf="maxCallsWidthCallFlow.options"
               label="Max Calls With Call Flow"
               [acModel]="maxCallsWidthCallFlow.current"
               [options]="maxCallsWidthCallFlow.options"
               [showTooltip]="true"
               tooltipText="Drag or Type Number"
               (acModelChange)="maxCallsWithCallFlowChange($event)"
    ></ac-slider>
</div>

